import React from 'react';
import { LanguageContext } from '../../utils/i18nProvider';

// 语言选项以母语展示，便于用户识别
const LANGUAGES = [
  { value: 'zh', label: '简体中文' },
  { value: 'zh-TW', label: '繁體中文' },
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
  { value: 'ja', label: '日本語' },
  { value: 'hu', label: 'Magyar' },
  { value: 'ko', label: '한국어' },
  { value: 'pt', label: 'Português' },
  { value: 'de', label: 'Deutsch' },
];

const fabStyle = {
  position: 'fixed',
  right: '0.4rem',
  bottom: 'calc(1rem + 100px)',
  width: '1.5rem',
  height: '1.5rem',
  borderRadius: '50%',
  background: '#ef7b24',
  color: '#fff',
  border: 'none',
  boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  zIndex: 1000,
};

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 999,
};

const panelStyle = {
  position: 'absolute',
  right: '0.4rem',
  bottom: 'calc(2.9rem + 100px)',
  background: '#fff',
  border: '1px solid #e8e8e8',
  borderRadius: '0.3rem',
  boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
  padding: '0.2rem 0',
  minWidth: '4rem',
  maxHeight: '60vh',
  overflowY: 'auto',
};

const itemStyle = {
  padding: '0.3rem 0.6rem',
  fontSize: '0.4rem',
  lineHeight: '1.4',
  color: '#333',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
};

class LanguageSwitcher extends React.PureComponent {
  static contextType = LanguageContext;

  state = {
    open: false,
  };

  toggle = () => this.setState(prev => ({ open: !prev.open }));

  handleSelect = (value) => {
    this.context.changeLanguage(value);
    this.setState({ open: false });
  };

  render() {
    const { lang } = this.context;
    const { open } = this.state;
    return (
      <React.Fragment>
        <button
          type="button"
          style={fabStyle}
          onClick={this.toggle}
          aria-label="切换语言"
        >
          <svg viewBox="0 0 24 24" width="0.7rem" height="0.7rem" fill="currentColor">
            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"/>
          </svg>
        </button>
        {open && (
          <div style={overlayStyle} onClick={this.toggle}>
            <div style={panelStyle} onClick={e => e.stopPropagation()}>
              {LANGUAGES.map(item => (
                <div
                  key={item.value}
                  style={{
                    ...itemStyle,
                    ...(item.value === lang
                      ? { color: '#ef7b24', fontWeight: 'bold' }
                      : {}),
                  }}
                  onClick={() => this.handleSelect(item.value)}
                >
                  {item.label}
                </div>
              ))}
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export { LanguageSwitcher };
